import React from 'react';
import { IconProps } from '.';

const SvgCart = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M4.946 5.25H1.5v-1.5h4.79l.33 3h15.882l-3.088 10.5H6.27l-1.323-12Zm1.84 3 .827 7.5h10.679l2.206-7.5H6.786Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M11 20a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16.5 21.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'
      />
    </svg>
  );
};

export default SvgCart;
